// src/features/inventory/services/stockLocations.js
import { apiClient } from '../../../services/api/client';

export const stockLocationsAPI = {
  getStockLocations: () =>
    apiClient.get('/api/v1/inventory/stock/locations/'),

  getStockLocationById: (stockLocationId) =>
    apiClient.get(`/api/v1/inventory/stock/locations/${stockLocationId}`),

  createStockLocation: (data) =>
    apiClient.post('/api/v1/inventory/stock/locations/', data),

  updateStockLocation: (stockLocationId, data) =>
    apiClient.put(`/api/v1/inventory/stock/locations/${stockLocationId}`, data),

  deleteStockLocation: (stockLocationId) =>
    apiClient.delete(`/api/v1/inventory/stock/locations/${stockLocationId}`),
};
